import {
  TERMINAL_INSTALLED_APP_TAB_FETCH_REQUEST,
  TERMINAL_INSTALLED_APP_TAB_FETCH_REQUEST_FAILURE,
  TERMINAL_INSTALLED_APP_TAB_FETCH_REQUEST_SUCCESS,
  TERMINAL_INSTALLED_APP_TAB_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const terminalInstalledAppTabsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TERMINAL_INSTALLED_APP_TAB_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TERMINAL_INSTALLED_APP_TAB_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.data.currentPage,
          pageSize: action.data.data.pageSize,
          total: action.data.data.totalRecord,
          totalPage: action.data.data.totalPage,
        },
      });

    case TERMINAL_INSTALLED_APP_TAB_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TERMINAL_INSTALLED_APP_TAB_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default terminalInstalledAppTabsReducer;
